import React from 'react'

const LoginBtn = props => {
    const {
        lock, btnName,
        onClickLogin,
     } = props

    return (
        <div className="oc-btnbox">
            {
                lock ? <a href="javascript:" className="btn-oc btn-oc-disable">{btnName}</a>
                     : <a href="javascript:" className="btn-oc" onClick={onClickLogin}>{btnName}</a>
            }
        </div>
    )
}

export default LoginBtn



// WEBPACK FOOTER //
// ./js/src/pages/Login/components/LoginBtn.jsx